import { Controller } from "@hotwired/stimulus";
import { toggleVisibility } from "../../shared/toggleVisibility";

/**
 * 本人確認書類画像を両面まとめて削除する。
 * drivers-license-image
 * app/views/secret_profiles/_form.html.erb 用。
 */
export default class extends Controller {
  static outlets = ["image-resize-preview", "identity-document-type"];
  static targets = ["registeredSection", "uploadSection", "clearButton"];

  connect() {
    this.#observeFormStatus();
    this.#toggleClearButton();
  }

  disconnect() {
    if (this.formStatusObserver) {
      this.formStatusObserver.disconnect();
      this.formStatusObserver = null;
    }
  }

  delete() {
    this.imageResizePreviewOutlets.forEach((controller) => {
      controller.delete();
    });
    // 登録済み表示を非表示にし、アップロードフォームを表示する
    if (this.hasRegisteredSectionTarget) {
      this.registeredSectionTarget.hidden = true;
    }
    if (this.hasUploadSectionTarget) {
      this.uploadSectionTarget.hidden = false;
    }
    // 裏面セクションも表示する（マイナンバーカード以外の場合）
    this.#showBackSectionIfNeeded();
    // 確認書類選択フォームを活性化する
    this.#enableDocumentTypeSelector();
    this.#toggleClearButton();
  }

  #showBackSectionIfNeeded() {
    if (!this.hasIdentityDocumentTypeOutlet) return;
    if (this.identityDocumentTypeOutlet.isMyNumberSelected()) return;

    this.identityDocumentTypeOutlet.showBackSection();
  }

  #enableDocumentTypeSelector() {
    if (!this.hasIdentityDocumentTypeOutlet) return;

    this.identityDocumentTypeOutlet.enableSelector();
  }

  #observeFormStatus() {
    if (!this.hasClearButtonTarget) return;

    this.formStatusObserver = new MutationObserver((mutations) => {
      if (
        mutations.some(
          (mutation) => mutation.attributeName === "data-form-status",
        )
      ) {
        this.#toggleClearButton();
      }
    });
    this.formStatusObserver.observe(this.element, {
      subtree: true,
      attributes: true,
      attributeFilter: ["data-form-status"],
    });
  }

  #toggleClearButton() {
    if (!this.hasClearButtonTarget) return;

    toggleVisibility(this.clearButtonTarget, this.#hasSelectedImages());
  }

  #hasSelectedImages() {
    return this.imageResizePreviewOutlets.some((controller) => {
      const formStatus = controller.element.dataset.formStatus;
      return ["preview", "pending", "saved"].includes(formStatus);
    });
  }
}
